import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBooleanGroupIntersect2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="boolean-group-intersect-2"><path d="M8.75 8.75V15.25H15.25M8.75 5V2.75H11M19 2.75H21.25V5M14 2.75H16M21.25 8V10M21.25 13V15.25H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M2.75 14V16M2.75 11V8.75H5M8.75 8.75H15.25V15.25M15.25 19V21.25H13M10 21.25H8M5 21.25H2.75V19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><rect x="9" y="9" width="6" height="6" fill="currentColor"/></CentralIconBase>;
};

export default IconBooleanGroupIntersect2;
